<template>
<div>
  <h4>
    <router-link :to="{'name': 'coachAssessmentResults', params: {id: assessment.id}}">{{assessment.full_name}} ({{createdAt(assessment.created_at)}})</router-link>
  </h4>
  <div>{{assessment.assessment.name }}</div>
  <div>{{assessment.email_address}}</div>
</div>
</template>

<script>
import moment from "moment";

export default {
  props: ["assessment"],
  methods: {
    createdAt(date) {
      return moment(date).format('MMM D, YYYY');
    }
  }
}
</script>
